import {KeyStringValue} from "../providers/service/global-variables.service";
import {PossibleCommandsType} from "../providers/service/all-devices.service";

export class Command {
    constructor(objectId: string, name: string, type: KeyStringValue<PossibleCommandsType>) {
        this.objectId = objectId;
        this.name = name;
        this.possibleCommands = type;
    }

    public objectId: string;
    public name: string;
    public possibleCommands
    public possibleCommand?: string
    public value?: number

    get commandType() {
        if (this.possibleCommands && this.possibleCommand && (this.possibleCommands as any)[this.possibleCommand].dataType) {
            return (this.possibleCommands as any)[this.possibleCommand].dataType
        } else {
            return
        }
    }

    public static build(shutter: Command | undefined): Command {
        if (shutter == null) return new Command(undefined as any, undefined as any, undefined as any)
        let s = new Command(shutter.objectId, shutter.name, shutter.possibleCommands);
        return s;
    }
}